/**
 * Locked AI Assist marketing copy (BTA-189).
 * Problem lines are the import-page H1s. Fix lines are the action
 * sentences those pages already use for the upload-and-review step.
 */

export const HOME_TITLE =
  "AI Bowling Tournament Software | Bowling Tournament App";

export const HOME_DESCRIPTION =
  "Bowling tournament software with AI Assist. Import league averages, paper signup sheets, and recap sheets from a photo. Free on your first tournament.";

export const HERO_H1 = "Fill the squads. Post the scores. Pay the board.";

export const HERO_SUB =
  "Signups, squads, scoring, and payouts on one board bowlers can see.";

export const AI_ASSIST_STRIP_HEADING =
  "Photograph the league sheet. Review the rows.";

export const PLANS_TITLE =
  "Bowling Tournament Software Pricing and AI Assist Plans";

export const PLANS_DESCRIPTION =
  "Free for up to 5 tournaments a year. AI Assist $99/year for AI imports and up to 20. Priority $149/year, unlimited, includes AI Assist.";

export const PLANS_H1 =
  "Run tournaments free. Add AI Assist when the paper piles up.";

export const PLANS_LEDE =
  "Free covers 5 tournaments a year. AI Assist reads your league averages, signup sheets, and recap sheets so you stop retyping them.";

export const PLANS_TEASER =
  "Free includes 5 tournaments per year. AI Assist is free on your first tournament.";

export const AI_ASSIST_CARD_LEDE =
  "AI imports for averages, signup sheets, and recap sheets.";

export const AI_ASSIST_PAGE = {
  to: "/bowling-tournament-ai-assist",
  label: "AI Assist",
  title: "Bowling Tournament AI Assist | Import Averages and Sheets",
  description:
    "Photograph league sheets, signup sheets, and recap sheets. Review the rows and use them on the tournament. Free on your first tournament.",
  heading: "Get paper off the tournament desk",
  lede: "League sheets, paper signup sheets, and recap sheets still land on the desk. Upload a photo or PDF, review the rows, and use them on the tournament.",
};

export const AI_ASSIST_IMPORTS = [
  {
    id: "averages",
    to: "/bowling-tournament-average-import",
    label: "Average import",
    title: "AI Average Import for Bowling Tournaments",
    heading: "Stop typing every league average by hand",
    lede: "AI Assist reads the league sheet.",
    fix: "Upload a photo or PDF of the league sheet. Review the rows.",
    landingHeading: "AI average import",
    shotKey: "averageImport",
    pageShotKey: "averageImport",
    cardLabel: "Average import",
  },
  {
    id: "signups",
    to: "/bowling-tournament-signup-sheet-import",
    label: "Signup sheet import",
    title: "AI Signup Sheet Import for Bowling Tournaments",
    heading: "Stop typing the paper sheet after they leave",
    lede: "AI Assist reads the signup sheet.",
    fix: "Photograph the signup sheet, check each row, and create the teams.",
    landingHeading: "AI signup sheet import",
    shotKey: "signupImportReview",
    pageShotKey: "signupImportResults",
    cardLabel: "Signup sheet import",
  },
  {
    id: "recaps",
    to: "/bowling-tournament-recap-sheet-import",
    label: "Recap sheet import",
    title: "AI Recap Sheet Import for Bowling Tournaments",
    heading: "Get games from paper recaps onto the board between squads",
    lede: "AI Assist reads the recap sheet.",
    fix: "Print the recap, photograph the filled sheet, and put the games on the right team.",
    landingHeading: "AI recap sheet import",
    shotKey: "recapImport",
    pageShotKey: "recapImport",
    cardLabel: "Recap sheet import for scores",
  },
];

export const aiAssistImport = (id) =>
  AI_ASSIST_IMPORTS.find((item) => item.id === id);

export const aiAssistStep = (id) => {
  const row = aiAssistImport(id);
  return {
    to: row.to,
    label: row.label,
    detail: `${row.heading}. ${row.fix}`,
  };
};

export const AI_ASSIST_NAV_GROUP = {
  id: "ai-assist",
  label: AI_ASSIST_PAGE.label,
  to: AI_ASSIST_PAGE.to,
  items: AI_ASSIST_IMPORTS.map((item) => ({
    to: item.to,
    label: item.label,
  })),
};
